import React from 'react';
import { Box, Heading, Link, List, Text, VStack } from '@chakra-ui/react';

const RefundPolicy = () => {
  return (
    <Box p={['5', '32']} className="backcolor" mt={'5vh'}>
      <VStack alignItems="flex-start" spacing="4">
        <Heading as="h1" fontSize="4xl" mb="4">
          Refund and Other Policy
        </Heading>
        <Text>
          Thanks for shopping at LearnWiz. We appreciate the fact that you like
          to buy the stuff we build. We also want to make sure you have a
          rewarding experience while you’re exploring, evaluating, and
          purchasing our products.
        </Text>
        <Text>
          As with any shopping experience, there are terms and conditions that
          apply to transactions at LearnWiz. We’ll be as brief as our attorneys
          will allow. The main thing to remember is that by placing an order or
          making a purchase at LearnWiz, you agree to the terms along with
          LearnWiz's Privacy Policy.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          FEES AND PAYMENT
        </Text>
        <Text>We accept the following forms of payment:</Text>
        <List fontWeight={'bold'}>
          <li>1.Visa</li>
          <li>2.Mastercard</li>
          <li>3.UPI</li>
        </List>
        <Text>
          You may be required to purchase or pay a fee to access some of our
          services. You agree to provide current, complete, and accurate
          purchase and account information for all purchases made via the Site.
          You further agree to promptly update account and payment information,
          including email address, payment method, and payment card expiration
          date, so that we can complete your transactions and contact you as
          needed. We bill you through an online billing account for purchases
          made via the Site. Sales tax will be added to the price of purchases
          as deemed required by us. We may change prices at any time. All
          payments shall be in U.S. dollars.
        </Text>
        <Text>
          You agree to pay all charges or fees at the prices then in effect for
          your purchases, and you authorize us to charge your chosen payment
          provider for any such amounts upon making your purchase. If your
          purchase is subject to recurring charges, then you consent to our
          charging your payment method on a recurring basis without requiring
          your prior approval for each recurring charge, until you notify us of
          your cancellation.
        </Text>
        <Text>
          We reserve the right to correct any errors or mistakes in pricing,
          even if we have already requested or received payment. We also reserve
          the right to refuse any order placed through the Site.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          CANCELLATION
        </Text>
        <Text>
          All purchases are non-refundable but if you cancel your subscription
          within 7-days of purchase you will get your full refund through your
          registered payment mode. You can cancel your subscription at any time
          by logging into your account. Your cancellation will take effect at
          the end of the current paid term.
        </Text>
        <Text>
          If you are unsatisfied with our services, please email us at
          LearnWizbusiness@gmail.com.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          Your Suggestions
        </Text>
        <Text>
          Any feedback, comments, ideas, improvements or suggestions
          (collectively, "Suggestions") provided by you to LearnWiz with respect
          to the website shall remain the sole and exclusive property of
          LearnWiz.
        </Text>
        <Text>
          LearnWiz shall be free to use, copy, modify, publish, or redistribute
          the Suggestions for any purpose and in any way without any credit or
          any compensation to you.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          Your Consent
        </Text>
        <Text>
          We've updated our Terms & Conditions to provide you with complete
          transparency into what is being set when you visit our site and how
          it's being used. By using our website, registering an account, or
          making a purchase, you hereby consent to our Terms & Conditions.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          Links to Other Websites
        </Text>
        <Text>
          This Terms & Conditions applies only to the Services. The Services may
          contain links to other websites not operated or controlled by
          LearnWiz. We are not responsible for the content, accuracy or opinions
          expressed in such websites, and such websites are not investigated,
          monitored or checked for accuracy or completeness by us. Please
          remember that when you use a link to go from the Services to another
          website, our Terms & Conditions are no longer in effect. Your browsing
          and interaction on any other website, including those that have a link
          on our platform, is subject to that website’s own rules and policies.
          Such third parties may use their own cookies or other methods to
          collect information about you.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          Cookies
        </Text>
        <Text>
          LearnWiz uses "Cookies" to identify the areas of our website that you
          have visited. A Cookie is a small piece of data stored on your
          computer or mobile device by your web browser. We use Cookies to
          enhance the performance and functionality of our website but are
          non-essential to their use. However, without these cookies, certain
          functionality like videos may become unavailable or you would be
          required to enter your login details every time you visit the website
          as we would not be able to remember that you had logged in previously.
          Most web browsers can be set to disable the use of Cookies. However,
          if you disable Cookies, you may not be able to access functionality on
          our website correctly or at all. We never place Personally
          Identifiable Information in Cookies.
        </Text>
        <Text fontWeight="bold" mt="4" fontSize={'2xl'}>
          Disclaimer
        </Text>
        <Text>
          LearnWiz is not responsible for any content, code or any other
          imprecision.
        </Text>
        <Text>LearnWiz does not provide warranties or guarantees.</Text>
        <Text>
          In no event shall LearnWiz be liable for any special, direct,
          indirect, consequential, or incidental damages or any damages
          whatsoever, whether in an action of contract, negligence or other
          tort, arising out of or in connection with the use of the Service or
          the contents of the Service. The Company reserves the right to make
          additions, deletions, or modifications to the contents on the Service
          at any time without prior notice.
        </Text>
        <Text>
          The LearnWiz Service and its contents are provided "as is" and "as
          available" without any warranty or representations of any kind,
          whether express or implied. LearnWiz is a distributor and not a
          publisher of the content supplied by third parties; as such, LearnWiz
          exercises no editorial control over such content and makes no warranty
          or representation as to the accuracy, reliability or currency of any
          information, content, service or merchandise provided through or
          accessible via the LearnWiz Service. Without limiting the foregoing,
          LearnWiz specifically disclaims all warranties and representations in
          any content transmitted on or in connection with the LearnWiz Service
          or on sites that may appear as links on the LearnWiz Service, or in
          the products provided as a part of, or otherwise in connection with,
          the LearnWiz Service, including without limitation any warranties of
          merchantability, fitness for a particular purpose or non-infringement
          of third party rights. No oral advice or written information given by
          LearnWiz or any of its affiliates, employees, officers, directors,
          agents, or the like will create a warranty. Price and availability
          information is subject to change without notice. Without limiting the
          foregoing, LearnWiz does not warrant that the LearnWiz Service will be
          uninterrupted, uncorrupted, timely, or error-free.
        </Text>
        <Text mt="4" fontWeight={'bold'}>
          For more information about the RefundPolicy, please{' '}
          <Link color="rgb(12,120,254)" href="/contact">
            contact us
          </Link>
        </Text>
        <Heading as="h2" fontSize="2xl" mt="8">
          Contact Us
        </Heading>
        <Text>Don't hesitate to contact us if you have any questions.</Text>
        <Text>Via Email: [khanwarish483@gmail.com]</Text>
        <Text>Via Phone Number: +919991463786</Text>
        <Text>At Office : Ferozepur Jhirka Nuh(mewat) Haryana - 122104.</Text>
      </VStack>
    </Box>
  );
};

export default RefundPolicy;
